
import React from "react";
import { format, parseISO } from "date-fns";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent
} from "@/components/ui/card";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend
} from "recharts";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent
} from "@/components/ui/chart";

interface RevenueBarChartProps {
  data: Array<{
    date: string;
    receita: number;
  }>;
}

const RevenueBarChart = ({ data }: RevenueBarChartProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Receita por dia</CardTitle>
        <CardDescription>
          Receita gerada pela campanha ao longo do tempo
        </CardDescription>
      </CardHeader>
      <CardContent className="h-[300px]">
        <ChartContainer
          config={{
            receita: { color: "#8B5CF6" },
          }}
        >
          <BarChart
            data={data}
            margin={{ top: 5, right: 30, left: 20, bottom: 25 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="date" 
              tickFormatter={(date) => format(parseISO(date), "dd/MM")}
              angle={-45}
              textAnchor="end"
              height={60}
            />
            <YAxis
              tickFormatter={(value) => `R$${value}`}
            />
            <ChartTooltip
              content={({ active, payload }) => (
                <ChartTooltipContent
                  active={active}
                  payload={payload}
                  labelFormatter={(value) => 
                    format(parseISO(value as string), "dd/MM/yyyy")
                  }
                />
              )}
            />
            <Legend />
            <Bar
              dataKey="receita"
              name="Receita"
              fill="var(--color-receita)"
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};

export default RevenueBarChart;
